import React from 'react'
import { Row, Spinner } from "react-bootstrap"
import AdminAllOrdersItem from './AdminAllOrdersItem'
import UseAllOrders from '../../CustomHooks/User/UseAllOrders'
import Pagination from '../Layout/Pagination'
import { ToastContainer } from 'react-toastify'


const AdminAllOrdersComp = () => {

  const [orderNumber, dataCards, paginate, onPress, handleChangeSearchInput, searchInputValue, loading] = UseAllOrders()

  return (
    <>
      <div className='d-flex flex-row justify-content-between m-3  mt-5 align-items-center'>
        <h3 className='fw-bold'>All Orders</h3>
      </div>
      {loading === false ? ((dataCards.length >= 1 ? (<>
        <div className='d-flex flex-row justify-content-between mx-3 mb-2 align-items-center'>
          <input type='text' className='form-control h-60 mb-4 fs-20 fw-bold' placeholder='Search by order number' value={searchInputValue} onChange={handleChangeSearchInput} />
        </div>
        {dataCards ? dataCards.map((item, index) => { return (<AdminAllOrdersItem item={item} key={index} />) }) : (<h3>No Orders To Show</h3>)}
        {paginate && paginate.numberOfPages > 1 ? (<Pagination pageCount={paginate.numberOfPages} onPress={onPress} />) : null}
        <ToastContainer/>
      </>) : (
        <div className='d-flex  align-items-center flex-column h-100'>
          <h3 className='alert alert-danger'>No Orders</h3>
        </div>
      ))) : (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
        <Spinner animation="border" variant="danger" />
      </div>)}

    </>
  )
}

export default AdminAllOrdersComp
